module.exports = __webpack_public_path__ + "img/223752.ccbb68cd.jpg";